'use strict';

import injector from 'vue-inject';
import anime from 'animejs';

class BackgroundEngine {
    constructor(){
        this.animationTypes = [
            'pulsate',
            'explosion',
            'wave'
        ];

        this.currentType = this.animationTypes[Math.floor(Math.random()*this.animationTypes.length)];

        this.winWidth = window.innerWidth;
        this.winHeight = window.innerHeight;

        // Particle collection - primarily used for background
        this.particles = {
            count : 0,          // Total particles
            startRadius : 1,
            maxRadius : 5,     // Max radius per particle in em
            padding : 5,
            grid : [0,0],
            renderKey : 0
        };

        this.animation = null;

        this.loop = true;

        // Bio animation parms
        this.bio = {
            paths: '../assets/img/avatars/0avatar.png',
            chosen: null,
            img : null,
            canvas: null,
            ctx : null,
            width : 0,
            height: 0
        };

        this.skill = {
            paths: [],
            canvas : null,
            ctx : null,
            width: 0,
            height: 0
        };        

        this.timeout = null;

        this.direction = {
            bio:false,
            skill:false,
            gallery:false
        };

        this.generateNumOfParticles();
    }

    // ======= PRE-RENDERS
    // Get us dots in background
    generateNumOfParticles(){
        // 1 em => 16px
        let emsX = this.winWidth/16;
        let emsY = this.winHeight/16;

        let cols = emsX/(2+this.particles.startRadius);
        let rows = emsY/(2+this.particles.startRadius);

        this.particles.grid[0] = Math.floor(cols);
        this.particles.grid[1] = Math.floor(rows);

        this.particles.count = this.particles.grid[0] * this.particles.grid[1];
    }

    // ======= RENDER DIMENSIONALS
    // Need to update # of particles
    // Need to update bio ascii
    resizeTriggered(event, refs){
        let pad = this.particles.padding || 0;
        let ctx = this;

        function resize(){
            let el = refs.parent;

            if(ctx.timeout) clearTimeout(ctx.timeout);
            
            anime.set(el, {scale: 1});
            let parentEl = el.parentNode;
            let elOffsetWidth = el.offsetWidth - pad;
            let parentOffsetWidth = parentEl.offsetWidth;
            let ratio = parentOffsetWidth / elOffsetWidth;
            ctx.timeout = setTimeout(function(){
                anime.set(el, {scale: ratio});
            }, 100);
        }
        resize();

        this.winWidth = event.target.innerWidth;
        this.winHeight = event.target.innerHeight;

        this.generateNumOfParticles();
    }

    configureCanvas(){
        // this.skill.canvas = document.getElementById("leftAnimator");
        // this.skill.ctx = this.skill.canvas.getContext("2d");

        // Get the device pixel ratio, falling back to 1.
        // let dpr = window.devicePixelRatio;

        // Get the size of the canvas in CSS pixels.
        // let rectSkill = this.skill.canvas.getBoundingClientRect();

        // Give the canvas pixel dimensions of their CSS
        // size * the device pixel ratio.
        // this.skill.canvas.width = rectSkill.width * dpr;
        // this.skill.canvas.height = rectSkill.height * dpr;

        // Scale all drawing operations by the dpr, so you
        // don't have to worry about the difference.
    }

    // ======= ANIMATOR ENGINE
    restartAnimation(){
        let startScale = this.particles.startRadius;
        anime.timeline({
            easing: 'easeInOutQuad'
        })
        // Hide bio animator
        .add({
            targets: '.animators',
            keyframes:[
                {
                    opacity: 0,
                    duration: 200
                }
            ]
        }, 500)
        // Set dots and background to original
        .add({
            targets: '.dot',
            keyframes:[
                {
                    scale : startScale,
                    duration: 500
                }, {
                    backgroundColor:'#000',
                    duration: 300
                }
            ]
        },200);

        this.animation.restart();
    }

    animate(){
        switch(this.currentType){
            case 'pulsate':
                this.animation = this.pulsate();
                break;
            case 'explosion':
                this.animation = this.explosion();
                break;
            case 'wave':
                this.animation = this.wave();
                break;
            default:
                this.animation = null;
                break;
        }
    }

    wave(){
        let startScale = this.particles.startRadius;
        let endScale = this.particles.maxRadius;

        let grid = this.particles.grid;

        return anime.timeline({
            easing: 'easeInOutQuad',
            loop: this.loop
        })
        .add({
            targets: '.dot',
            keyframes: [
                {
                  translateX: anime.stagger('-=10px', {grid: grid, from: 'first', axis: 'x'}),
                  duration: 800
                }, {
                  translateX: anime.stagger('5px', {grid: grid, from: 'first', axis: 'x'}),
                  scale: anime.stagger([endScale/startScale, 2], {grid: grid, from: 'first', axis: 'x'}),
                  duration: 800
                }, {
                  translateX: 0,
                  scale : 1,
                  duration: 1200,
                }
            ],
            delay: anime.stagger(100, {grid: grid, from: 'first', axis: 'x'})
        }, 300);
    }

    explosion(){
        let startScale = this.particles.startRadius;
        let endScale = this.particles.maxRadius;

        let grid = this.particles.grid;

        return anime.timeline({
            easing: 'easeInOutQuad',
            loop: this.loop
        })
        .add({
            targets: '.dot',
            keyframes: [
                {
                  translateY: anime.stagger('-2px', {grid: grid, from: 'center', axis: 'y'}),
                  translateX: anime.stagger('-2px', {grid: grid, from: 'center', axis: 'x'}),
                  duration: 100
                }, {
                  translateY: anime.stagger('4px', {grid: grid, from: 'center', axis: 'y'}),
                  translateX: anime.stagger('4px', {grid: grid, from: 'center', axis: 'x'}),
                  scale: anime.stagger([endScale/startScale, 1], {grid: grid, from: 'center'}),
                  duration: 225
                }, {
                  translateX: 0,
                  translateY: 0,
                  scale: 1,
                  duration: 800,
                }

            ],
            delay: anime.stagger(80, {grid: grid, from: 'center'})
        }, 300);
    }

    pulsate(){
        let startScale = this.particles.startRadius;
        let endScale = this.particles.maxRadius-1;

        return anime.timeline({
            easing: 'easeInOutQuad',
            loop: this.loop
        })
        .add({
            targets: '.dot',
            keyframes: [
                {
                  scale: [0.5, endScale/startScale],
                  duration: 900
                }, {
                  scale: [endScale/startScale, 0.5],
                  duration: 900
                }
            ],
        }, 500);
    }

    animateEnter(){
        this.animation.pause();

        anime.timeline({
            easing: 'easeInOutQuad'
        })
        // Shrink to min size and set background to white
        .add({
            targets: '.dot',
            keyframes:[
                {
                    scale : 0,
                    duration: 500
                }, {
                    backgroundColor:'#fff',
                    duration: 300
                }
            ],
        })
        // Display bio animator
        .add({
            targets: '.animators',
            keyframes:[
                {
                    opacity: 1,
                    duration: 200
                }
            ]
        },200);
    }

    animateSkillExit(){
        let startScale = this.particles.startRadius;
        anime.timeline({
            easing: 'easeInOutQuad'
        })
        // Hide animators
        .add({
            targets: '.animators',
            keyframes:[
                {
                    opacity: 0,
                    duration: 200
                }
            ]
        },200)
        // Set scale to 0 and background to white
        .add({
            targets: '.dot',
            keyframes:[
                {
                    scale : startScale,
                    duration: 500
                }, {
                    backgroundColor:'#FFF',
                    duration: 300
                }
            ],
        },200);
    }
}

injector.service('backgroundEngine', BackgroundEngine);